import { GatewayClientProvider } from './../gateway-client/gateway-client';
import { Injectable } from '@angular/core';
// import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

/*
  Generated class for the MessagesProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class MessagesProvider {
  constructor(
    public gateway: GatewayClientProvider,
  ) {
  }
  getMessages(body) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getMessages(body)
        .then((data) => {
          resolve(data);
        }).catch((error) => {
          reject(error);
        })
    })
  }
  registerMessageAction(message, url) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.registerMessageAction(message, url)
        .then((data) => {
          resolve(data);
        }).catch((error) => {
          reject(error);
        })
    })
  }
  messageViewed(message) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.messageViewed(message)
        .then((data) => {
          resolve(data);
        }).catch((error) => {
          reject(error);
        })
    })
  }
  getNewMessagesCount() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getNewMessageCount()
        .then((count) => {
          resolve(count);
        }).catch((error) => {
          reject(error);
        })
    });
  }

  isMessageRead(pushmessagesid) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.isMessageRead(pushmessagesid)
        .then((data) => {
          resolve(data);
        }).catch((error) => {
          reject(error);
        })
    });
  }

  isMessageInterested(pushmessagesid) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.isMessageInterested(pushmessagesid)
        .then(() => {
          resolve(true);
        }).catch((error) => {
          reject(error);
        })
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/messages/messages.ts